export const TYPE_OPTIONS = [
  { label: "Logs", value: "PROCESSING" },
  { label: "Content", value: "SPOTLIGHT" }
];
export var PackTypes = /* @__PURE__ */ ((PackTypes2) => {
  PackTypes2["PROCESSING"] = "PROCESSING";
  PackTypes2["SPOTLIGHT"] = "SPOTLIGHT";
  return PackTypes2;
})(PackTypes || {});
